import React from 'react';

import useGlobalStore from 'hooks/useGlobalStore';

import CO2ESavedIcon from '../Account/CO2ESavedIcon';
import { Vegetables } from '../Aisles/Icons/Vegetables';
import IFProduce from '../Aisles/Produce/IFProduce';
import MMProduce from '../Aisles/Produce/MMProduce';

import AllPreferencesIcon from './AllPreferencesIcon';
import CertifiedKosherIcon from './CertifiedKosherIcon';
import DairyFreeIcon from './DairyFreeIcon';
import { EatItAllIcon } from './EatItAllIcon';
import GlutenFreeIcon from './GlutenFreeIcon';
import KetoIcon from './KetoIcon';
import MajorAllergenFreeIcon from './MajorAllergenFreeIcon';
import NonGMOIcon from './NonGMOIcon';
import PaleoIcon from './PaleoIcon';
import PescatarianIcon from './PescatarianIcon';
import PlantBasedIcon from './PlantBasedIcon';
import VeganIcon from './VeganIcon';
import VegetarianIcon from './VegetarianIcon';
import Whole30Icon from './Whole30Icon';

const DietaryPreferencesIcons = {
    AllPreferencesIcon,
    CO2ESavedIcon,
    CertifiedKosherIcon,
    DairyFreeIcon,
    EatItAllIcon,
    GlutenFreeIcon,
    KetoIcon,
    IFProduce,
    MajorAllergenFreeIcon,
    MMProduce,
    NonGMOIcon,
    PaleoIcon,
    PescatarianIcon,
    PlantBasedIcon,
    VeganIcon,
    VegetarianIcon,
    Whole30Icon,
    Vegetables,
};

function DietaryPreferencesIcon({ dietaryPreferencesIconName, ...props }) {
    const { isMisfitsTheme } = useGlobalStore();

    // add dynamic prefix for produce icon
    const brandPrefix = isMisfitsTheme ? 'MM' : 'IF';
    const produceIcon = dietaryPreferencesIconName === 'Produce';
    const iconName = produceIcon ? `${brandPrefix}Produce` : dietaryPreferencesIconName;

    const DietaryPreferencesIconName = DietaryPreferencesIcons[iconName];
    return <DietaryPreferencesIconName {...props} />;
}

export {
    AllPreferencesIcon,
    CertifiedKosherIcon,
    DairyFreeIcon,
    DietaryPreferencesIcon,
    EatItAllIcon,
    GlutenFreeIcon,
    KetoIcon,
    MajorAllergenFreeIcon,
    NonGMOIcon,
    PaleoIcon,
    PescatarianIcon,
    PlantBasedIcon,
    VeganIcon,
    VegetarianIcon,
    Whole30Icon,
};
